import React, { useEffect, useState, useContext } from 'react';
import Header from '../Header';
import axios from 'axios';
import { UserContext } from "../UserContext";
import { useNavigate } from 'react-router-dom';
import './index.css';
import { toast, ToastContainer, Zoom } from 'react-toastify';

const OperatorList = () => {
  const { user, token, tempLogin  } = useContext(UserContext);
  const [operators, setOperators] = useState([]);  
  const [allOperators, setAllOperators] = useState([]);  
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedOperator, setSelectedOperator] = useState(null);
  const [balanceAmount, setBalanceAmount] = useState('');
  const [remarks, setRemarks] = useState('');
  const [showBalanceForm, setShowBalanceForm] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const isSuperAdmin = user.role === 'superadmin';  

  const openAddBalanceForm = (operator) => {
    setSelectedOperator(operator);
    setBalanceAmount('');
    setRemarks('');
    setShowBalanceForm(true);
  };

  const [showEditForm, setShowEditForm] = useState(false);
  const [editForm, setEditForm] = useState({
    id: '',
    username: '',
    password: '',
    networkName: '',
    operatorName: '',
    phoneNumber: '',
    Email: '',
    address: '',
    packPrice: ''
  });

  const navigate = useNavigate();

  const fetchOperators = async () => {
    try {
      const response = await fetch(`https://vrplay.in/portal_php/operator_api.php?filterRole=operator`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (response.ok) {
        setOperators(data.operators);
        setError(null);
      } else {
        setError(data.error || 'Failed to fetch operators');
      }
    } catch (err) {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  };

  const fetchAllOperators = async () => {
    try {
      const response = await fetch(`https://vrplay.in/portal_php/operator_api.php`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (response.ok) {
        setAllOperators(data.operators);
        setError(null);
      } else {
        setError(data.error || 'Failed to fetch operators');
      }
    } catch (err) {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOperators();
    fetchAllOperators();
  }, []);

  const fetchOperatorsSearch = async (name = '') => {
    setLoading(true);
    try {      
      // Construct the URL with encoded parameters
      const url = `https://vrplay.in/portal_php/searchOperatorsByName.php?` +
                  `name=${encodeURIComponent(name)}&role=operator`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data && response.data.status === 'success') {
        setOperators(response.data.operators || []);
      } else {
        setOperators([]);
        // console.warn('No operators found or unexpected response:', response.data);
      }
    } catch (error) {
      // console.error('Error fetching operators:', error);
      setOperators([]);
    } finally {
      setLoading(false);
    }
  };

  const handleAddBalance = async () => {
    if (!balanceAmount || isNaN(balanceAmount)) {
      toast.warn("Please enter a valid amount.");
      return;
    }
    
    if (selectedOperator.created_by !== user.operatorId){
      if (!window.confirm("Are you sure, you want Add Balance to admin operator?")) return;
    }
    const added_by = `${user.operatorName}, ${user.phoneNumber}`;

    try {
      const response = await axios.post(
        "https://vrplay.in/portal_php/addBalance.php",
        {
          id: selectedOperator.id,
          amount: parseFloat(balanceAmount), // safer than parseInt
          added_by,
          remarks,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // ensure proper header
          },
        }
      );

      if (response.data.status === "success") {
        toast.success("Balance updated successfully!");
        searchTerm ? fetchOperatorsSearch(searchTerm) : fetchOperators();
        setShowBalanceForm(false);
        closeProfileModal();
      } else {
        toast.error("Failed: " + (response.data.error || "Unknown error"));
      }
    } catch (error) {
      console.error("Add balance error:", error);
      toast.warn("Failed to update balance. Please try again.");
    }
  };


  const openEditOperatorForm = (operator) => {
    setEditForm({
      id: operator.id,
      username: operator.username,
      password: operator.password,
      networkName: operator.networkName,
      operatorName: operator.operatorName,
      phoneNumber: operator.phoneNumber,
      Email: operator.Email,
      address: operator.address,
      packPrice: operator.packPrice,
      operCode: operator.operCode,
      watchoOperCode: operator.watchoOperCode,
      role: operator.role,
      created_by: operator.created_by,
    });
    setShowEditForm(true);
  };

  const handleEditChange = (e) => {
    setEditForm({
      ...editForm,
      [e.target.name]: e.target.value
    });
  };

  const submitEditForm = async () => {
    try {
      await axios.put('https://vrplay.in/portal_php/operator_api.php', editForm, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success('Operator updated successfully!');
      searchTerm ? fetchOperatorsSearch(searchTerm) : fetchOperators();
      setShowEditForm(false);
      closeProfileModal();
    } catch (err) {
      // console.error(err);
      toast.error('Failed to update operator');
    }
  };

  const openProfileModal = (operator) => {
    setSelectedOperator(operator);
  };

  const closeProfileModal = () => {
    setSelectedOperator(null);
  };

  const tempLoginOperator = async (targetUserId) => {
    const res = await fetch("https://vrplay.in/portal_php/impersonate.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({ targetUserId })
    });

    const data = await res.json();

    if (res.ok && data.token) {
      tempLogin(data.token);
    } else {
      toast.warn("Impersonation failed: " + (data.error || "Unknown error"));
    }
  };

  return (
    <>
    <Header />
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
      transition={Zoom}
    />

    <div className="operator-header">
      <h2>Operators</h2>
      <input
        type="text"
        placeholder="Search by name or phone"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onKeyUp={(e) => fetchOperatorsSearch(e.target.value)}
        className="search-input"
      />
      <button className="add-operator-btn" onClick={() => navigate('/add-operator')}>
        + Add Operator
      </button>
    </div>

    {error ? (
        <p className='error'>error</p>
      ) : (
        loading ? (<>
          <div className="skeleton-loader">
            {[...Array(6)].map((_, index) => (
              <div key={index} className="skeleton-row">
                <div className="skeleton-cell"></div>
                <div className="skeleton-cell"></div>
                <div className="skeleton-cell"></div>
                <div className="skeleton-cell"></div>
                <div className="skeleton-cell"></div>
                <div className="skeleton-cell"></div>
                <div className="skeleton-cell"></div>
                <div className="skeleton-cell"></div>
                <div className="skeleton-cell"></div>
              </div>
            ))}
          </div>
          </>
        ) : ( 
        <div className="operator-list">
          <div className="operator-table-wrapper">
            <table className="operator-table" id="operatorsTable">
              <thead>
                  <tr>
                  <th>ID</th>
                  <th>Username</th>
                  <th>Network Name</th>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Wallet</th>
                  <th>Created By</th>
                  <th>Address</th>
                  <th>Action</th>
                  </tr>
              </thead>
              <tbody>
                  {operators.length > 0 ? (
                    operators.map((operator, index) => (
                    <tr 
                        key={operator.id}
                        className={index % 2 === 0 ? 'even-row' : 'odd-row'}
                    >
                        <td>{index + 1}</td>
                        <td>
                          <button
                            onClick={() => openProfileModal(operator)}
                            style={{
                              color: '#007bff',
                              textDecoration: 'underline',
                              background: 'none',
                              border: 'none',
                              cursor: 'pointer',
                              padding: 0,
                              fontWeight: 'bold'
                            }}
                          >
                            {operator.username}
                          </button>
                        </td>
                        <td>{operator.networkName}</td>
                        <td>{operator.operatorName}</td>
                        <td>{operator.phoneNumber}</td>
                        <td>{operator.wallet}</td>
                        <td>{operator.created_by_name}</td>
                        <td>{operator.address}</td>
                        <td>
                          <button className='oper-assign-pack' onClick={() => navigate(`/assign-plans/${operator.id}`)}>
                            Assign Packages
                          </button>
                        </td>
                    </tr>
                    ))) : (
                      <tr>
                        <td colSpan="10" style={{ textAlign: 'center', padding: '20px', fontStyle: 'italic' }}>
                          No Operators Found
                        </td>
                      </tr>
                    )}
              </tbody>
            </table>
          </div>
          
          {selectedOperator && (
            <div className="modal-overlay">
              <div className="modal-content operator-profile-modal">
                
                <div className="operator-profile-content">
                  {/* Profile Header */}
                  <div className="profile-header">
                    <div className="operator-avatar">
                      {selectedOperator.operatorName ? selectedOperator.operatorName.charAt(0).toUpperCase() : 'O'}
                    </div>
                    <div className='operator-close'>
                      <div className="operator-info">
                        <h2>{selectedOperator.operatorName || 'No Name'}</h2>
                        <p>@{selectedOperator.role}</p>
                      </div>
                      <button onClick={closeProfileModal} className="close-btn">×</button>
                    </div>
                  </div>

                  {/* Details Section */}
                  <div className="details-section">
                    <div className="detail-group">
                      <div className="detail-item">
                        <span className="detail-label">Network Name: </span>
                        <span className="detail-value">{selectedOperator.networkName || 'Not specified'}</span>
                      </div>
                      
                      <div className="detail-item">
                        <span className="detail-label">Phone Number: </span>
                        <span className="detail-value">{selectedOperator.phoneNumber}</span>
                      </div>
                    </div>

                    <div className="detail-group price-group">
                      <div className="detail-item highlight">
                        <span className="detail-label">Wallet Balance: </span>
                        <span className="detail-value">₹{selectedOperator.wallet}</span>
                      </div>
                    </div>

                    <div className="detail-item full-width">
                      <span className="detail-label">Address: </span>
                      <span className="detail-value">{selectedOperator.address}</span>
                    </div>
                    
                  </div>

                  {/* Action Buttons */}
                  <div className="oper-buttons">
                    <button className='oper-btn oper-btn-edit' onClick={() => openEditOperatorForm(selectedOperator)}>
                      Edit Profile
                    </button>
                    <button className='oper-btn oper-btn-balance' onClick={() => openAddBalanceForm(selectedOperator)}>
                      Add Balance
                    </button>
                    <button onClick={() => tempLoginOperator(selectedOperator.id)} className="oper-btn oper-btn-login">
                      Login as Operator
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showBalanceForm && selectedOperator && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h3>Add Balance to: {selectedOperator.operatorName}</h3>
              <p>Current Wallet: ₹{selectedOperator.wallet}</p>
              <input
                type="number"
                placeholder="Enter amount"
                value={balanceAmount}
                onChange={(e) => setBalanceAmount(e.target.value)}
              />
              <input
                type="text"
                placeholder="Remarks"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />
              <div className="modal-buttons">
                <button className="btn" onClick={handleAddBalance}>Submit</button>
                <button className="btn cancel-btn" onClick={() => setShowBalanceForm(false)}>Cancel</button>
              </div>
            </div>
          </div>
        )}


        {showEditForm && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h3>Edit Operator: {editForm.operatorName}</h3>
              <label>Username:</label>
              <input name="username" placeholder="Username" value={editForm.username} onChange={handleEditChange} />
              <div className="password-wrapper">
                <label>Password:</label>
                <input 
                  name="password" 
                  type={showPassword ? "text" : "password"} 
                  placeholder="New Password" 
                  value={editForm.password} 
                  onChange={handleEditChange} 
                />
                <span 
                  className="password-toggle" 
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? "👁️" : "👁️‍🗨️"}
                </span>
              </div>
              <label>Network Name:</label>    
              <input name="networkName" placeholder="Network Name" value={editForm.networkName} onChange={handleEditChange} />
              <label>Operator Name</label>
              <input name="operatorName" placeholder="Operator Name" value={editForm.operatorName} onChange={handleEditChange} />
              <label>Phone Number</label>
              <input name="phoneNumber" placeholder="Phone Number" value={editForm.phoneNumber} onChange={handleEditChange} />
              <label>Email ID:</label>
              <input name="Email" placeholder="Email" value={editForm.Email} onChange={handleEditChange} />
              <label>Address</label>
              <input name="address" placeholder="Address" value={editForm.address} onChange={handleEditChange} />

              {/* 🔐 Only for SuperAdmin */}
              {isSuperAdmin && (
                <>
                  <label>OTTPlay Operator Code:</label>
                  <input name="operCode" placeholder="OTTPlay Operator Code" value={editForm.operCode} onChange={handleEditChange} />
                  
                  <label>Watcho Operator Code:</label>
                  <input name="watchoOperCode" placeholder="Watcho Operator Code" value={editForm.watchoOperCode} onChange={handleEditChange} />
                  
                  <label>Role:</label>
                  <select name="role" value={editForm.role} onChange={handleEditChange}>
                    <option value="operator">Operator</option>
                    <option value="admin">Admin</option>
                  </select>
                  
                  <label>Created by:</label>
                  <select
                    name="created_by"
                    value={editForm.created_by}
                    onChange={handleEditChange}
                  >
                    {allOperators.filter(oper => oper.role === "admin").map(oper => (
                      <option key={oper.id} value={oper.id}>
                        {oper.operatorName}
                      </option>
                    ))}
                  </select>
                </>
              )}

              <div className="modal-buttons">
                <button className="btn" onClick={submitEditForm}>Update</button>
                <button className="btn cancel-btn" onClick={() => setShowEditForm(false)}>Cancel</button>
              </div>
            </div>
          </div>
        )}

        </div>
      )
    )}
    </>
  );
};

export default OperatorList;
